import { FC } from 'react';

import { UserPopover } from '@bonusly/common-user-popover';

import { ProfileLink } from '../../../../../modules/profile/components/profile-link';
import { Bonus } from '../../../../../types/bonus';
import { BonusFeedTrackedAction, useTrackBonusFeedItemEvent } from '../../hooks/use-bonus-feed-item-analytics';

interface GiverNameProps {
	bonus: Bonus;
	disablePopover?: boolean;
}

export const GiverName: FC<GiverNameProps> = ({ bonus, disablePopover = false }) => {
	const { initiator, giver, hide_giver } = bonus;

	const trackGiverClick = useTrackBonusFeedItemEvent(bonus, BonusFeedTrackedAction.GiverClick);

	const trackInitiatorClick = useTrackBonusFeedItemEvent(bonus, BonusFeedTrackedAction.InitiatorClick);

	if ((!giver && !initiator) || hide_giver) {
		return null;
	}

	const onClick = initiator ? trackInitiatorClick : trackGiverClick;
	const user = initiator || giver;

	return (
		<>
			<UserPopover userId={user.id} openDelay={500} placement="top" isDisabled={disablePopover}>
				<ProfileLink
					userId={user.id}
					color="inherit"
					onClick={(e) => {
						e.stopPropagation();
						onClick();
					}}
				>
					{user.display_name}
				</ProfileLink>
			</UserPopover>
			:
		</>
	);
};
